"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EServicesReport_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EServicesReport_Factory = /** @class */ (function () {
    function EServicesReport_Factory() {
    }
    EServicesReport_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            FileName: model.FileName,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SourceFileName: model.SourceFileName,
            Status: model.Status,
        };
        return result;
    };
    EServicesReport_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            FileName: model.FileName,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SourceFileName: model.SourceFileName,
            Status: model.Status,
        };
        return result;
    };
    return EServicesReport_Factory;
}());
exports.EServicesReport_Factory = EServicesReport_Factory;
